import {Sequence} from 'components/Sequence';
import {Strand} from 'constants/MolbioConstants';
import {BiointelligentLinkType} from 'molbio/biointelligent-links/BiointelligentLinkConstants';
import {RED_POWDER, RED_DARK, GRAY} from 'ui-library/Colors';

// Sizing and spacing
export const LINK_NAME_FONT_SIZE = 13;
export const SINGLE_ANNOTATION_HEIGHT = 18;
export const SINGLE_ANNOTATION_RADIUS = 4;
export const SINGLE_ANNOTATION_BORDER = 1;
export const BORDER_LINE_HEIGHT = 3;
export const BORDER_LINE_GAP = 1;
// Number of pixels to show link background above and below the residues
export const NUCLEOTIDE_RESIDUE_MARGIN = 2;

// Linked item chip values
export const LINKED_ENTITY_CHIP_VERTICAL_PADDING = 1;
export const LINKED_ENTITY_CHIP_HORIZONTAL_PADDING = 2;
export const LINKED_ENTITY_CHIP_ICON_SIZE = 12;
export const LINKED_ENTITY_CHIP_HEIGHT = SINGLE_ANNOTATION_HEIGHT - LINKED_ENTITY_CHIP_VERTICAL_PADDING * 2;

// Colors
export const LINK_HIGHLIGHT_COLOR = '#DEDEE0';
export const LINK_HIGHLIGHT_HOVER_COLOR = '#C4C4C4';
export const LINK_HIGHLIGHT_FILL_OPACITY = 0.75;
export const LINK_HIGHLIGHT_STROKE_WIDTH = 0;
export const LINK_HIGHLIGHT_STROKE_OPACITY = 0.75;

// Parts colors.
export const PART_LINK_ARROW_COLOR = '#CFE6E8';
export const PART_ANNOTATION_COLOR = '#0B818E';
export const PART_LINK_CHIP_TEXT_COLOR = '#085159';
export const PART_ANNOTATION_OUT_OF_SYNC_COLOR = RED_DARK;
export const PART_ANNOTATION_ARCHIVED_COLOR = GRAY;
export const PART_ANNOTATION_ARCHIVED_OPACITY = 0.5;
export const LEGACY_PART_HIGHLIGHT_OUT_OF_SYNC_COLOR = RED_POWDER;
export const LEGACY_PART_STROKE_COLOR = GRAY;

// Transcription colors.
export const TRANSCRIPTION_COLOR = '#F9B93C';
// White with 80% opacity lets some of the background orange through.
export const TRANSCRIPTION_ARROW_COLOR = '#FFFFFFCC';
export const TRANSCRIPTION_CHIP_TEXT_COLOR = '#805D35';

// Values for links to DNA sequences
export const DNA_PART_TICK_HEIGHT = 3.5;
export const DNA_PART_ARROW_TIP_WIDTH = 10;
export const DNA_PART_ARROW_TIP_HEIGHT = 6;
export const DNA_PART_TICK_SPACING = 6;

// Values for transcription links to RNA sequences
export const TRANSCRIPTION_TICK_HEIGHT = 3.5;
export const TRANSCRIPTION_ARROW_TIP_WIDTH = 12;
export const TRANSCRIPTION_ARROW_TIP_HEIGHT = 8;
export const TRANSCRIPTION_TICK_SPACING = 6;

// Values for links to proteins
export const LINK_TO_PROTEIN_ANNOTATION_PADDING = 1;
export const LINK_TO_PROTEIN_ANNOTATION_HEIGHT = 16;
export const LINK_TO_PROTEIN_ANNOTATION_VMARGIN = 2;
export const LINK_TO_PROTEIN_ARROW_TIP_HEIGHT = 8;
export const LINK_TO_PROTEIN_ARROW_CIRCLE_RADIUS = 2;
export const LINK_TO_PROTEIN_DOT_SPACING = 12;

export const VALID_NUCLEOTIDE_LINK_TYPES = [
  BiointelligentLinkType.RNA_PART,
  BiointelligentLinkType.DNA_PART,
  BiointelligentLinkType.TRANSLATION,
  BiointelligentLinkType.TRANSCRIPTION,
];
export interface BiointelligentLinkHighlightRegion {
  start: number;
  end: number;
  /** Links has one entry per link that crosses this region. */
  links: Array<ViewBiointelligentLinkData>;
  highlightedStrand: Strand;
}

export interface ViewBiointelligentLinkData {
  // For nucleotide parts, this ID may be the database ID of the part.
  // For other types of links, it will be generated on the frontend.
  id: string;
  start: number;
  end: number;
  name: string;
  isArchived: boolean;
  outOfSync: boolean;
  linkType: BiointelligentLinkType;
  highlightedStrand: Strand;
}

export interface BiointelligentLinkAnnotation {
  // For nucleotide parts, this ID may be the database ID of the part.
  // For other types of links, it will be generated on the frontend.
  id: string;
  start: number;
  end: number;
  linkedEntityId: string;
  isInSync: boolean;
  isArchived: boolean;
  isSelected: boolean;
  name: string;
  onClick: (sequence: Sequence, shiftKey: boolean) => void;
  onDoubleClick: (sequence: Sequence, shiftKey: boolean) => void;
  layerIndex: number;
  linkType: BiointelligentLinkType;
  direction: Strand;
  drawStart?: number;
  drawEnd?: number;
}

export interface HoveredLinkIndices {
  start: number;
  end: number;
  highlightedStrand: Strand;
}
